export const PRIMARY_SEGMENT_ENUM = [
  'CRV',
  'MidSUV',
  'Sedan',
  'Truck',
  'Mixed',
] as const;

export const FIELD_NAME_ENUM = [
  'voi_model',
  'New_Auto_Class',
  'CATCHALL',
] as const;

export const FIELD_VALUE_ENUM = [
  'CRV',
  'CR-V',
  'CR-V HYBRID',
  'HRV',
  'ODYSSEY',
  'PASSPORT',
  'PILOT',
  'PROLOGUE',
  'ACCORD',
  'ACCORD HYBRID',
  'CIVIC',
  'CIVIC HYBRID',
  'PRELUDE',
  'CIVIC SI',
  'CIVIC TYPE R',
  'FIT',
  'INSIGHT',
  'RIDGELINE',
  'BUDGET EV',
  'LUXURY EV',
  'SMALL SUV',
  'MID SIZE SUV',
  'FULL SIZE SUV',
  'SMALL CAR',
  'MID SIZE CAR',
  'FULL SIZE CAR',
  'MINIVAN',
  'TRUCK',
] as const;

export const QUALIFIER_ENUM = [
  'Starts with',
  'Contains',
  'Matches',
] as const;

export const TERTIARY_SEGMENT_ENUM = [
  'Compact SUV',
  'Hybrid SUV',
  'Sub Compact SUV',
  'Minivan',
  'Mid Size SUV',
  'EV',
  'Mid Size Car',
  'Compact Car',
  'Sport Car',
  'Mid Size Truck',
  'Full Size SUV',
  'Truck',
] as const;

export const PRIORITY_ENUM = [1, 2, 3] as const;
